import { useState } from "react";
import beforeImg from "@/assets/before-floor.jpg";
import afterImg from "@/assets/after-floor.jpg";

export function BeforeAfter() {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative w-full aspect-[16/10] rounded-lg overflow-hidden border border-border shadow-elev select-none">
      <img src={afterImg} alt="Hardwood floor after refinishing" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={beforeImg} alt="Worn hardwood floor before refinishing" className="absolute inset-0 h-full w-full object-cover" style={{ width: `${100 / (pos / 100)}%`, maxWidth: "none" }} loading="lazy" />
      </div>
      <div className="absolute top-4 left-4 bg-foreground/85 text-background text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider">Before</div>
      <div className="absolute top-4 right-4 bg-accent text-accent-foreground text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider">After</div>
      <div className="absolute inset-y-0 w-0.5 bg-accent shadow-gold pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-10 w-10 rounded-full bg-accent border-4 border-background shadow-gold flex items-center justify-center">
          <span className="text-accent-foreground text-xs font-bold">↔</span>
        </div>
      </div>
      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Before/after slider"
        className="absolute inset-0 h-full w-full opacity-0 cursor-ew-resize"
      />
    </div>
  );
}
